import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {ANDROID_APP} from '../core/androidApp'
import {installedAppIcon} from '../core/useInstallState'

/**
 * «برنامهٔ اندروید» in the install guide, above the web app's own steps: the app's file (one tap
 * downloads it), the two steps of a first install, the stores once it is published there, and its
 * download page.
 */
export const AndroidAppCard: FC = () => (
  <section className='ia-android' aria-labelledby='ia-android-title'>
    <div className='ia-android__head'>
      <img src={toAbsoluteUrl(installedAppIcon())} alt='' width={44} height={44} />
      <div>
        <h3 id='ia-android-title' className='ia-android__title'>
          برنامهٔ اندروید معتمد آسا
        </h3>
        <p className='ia-android__text'>
          ذخیرهٔ فایل در پوشهٔ Download، چاپ و PDF، اعلان‌های پنل بی‌نیاز از سرویس‌های گوگل و قفل
          اثر انگشت.
        </p>
      </div>
    </div>
    <a className='btn btn-primary ia-android__download' href={ANDROID_APP.apk} download>
      <i className='las la-download' aria-hidden='true' />
      دانلود برنامهٔ اندروید
    </a>
    {ANDROID_APP.stores.length > 0 && (
      <div className='ia-android__stores'>
        {ANDROID_APP.stores.map((store) => (
          <a
            key={store.name}
            className='btn btn-sm btn-light'
            href={store.url}
            target='_blank'
            rel='noopener noreferrer'
          >
            دریافت از {store.name}
          </a>
        ))}
      </div>
    )}
    <ol className='ia-android__steps'>
      <li>
        فایل دریافت‌شده را باز کنید؛ اگر گوشی پرسید، «اجازه از این منبع» را برای مرورگر روشن کنید.
      </li>
      <li>«نصب» را بزنید، برنامه را باز کنید و با همین حساب وارد شوید.</li>
    </ol>
    <a
      className='ia-android__more'
      href={ANDROID_APP.page}
      target='_blank'
      rel='noopener noreferrer'
    >
      صفحهٔ برنامه و راهنمای کامل نصب
    </a>
  </section>
)
